import lessRequire from '../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';

import NewsList from './components/table/list';
import Filters from './components/filter/main';

lessRequire('modules/news/main.less');

const Main = renderViewsState(props => (
	<div className="container__with-columns container news-container">
		<div className="column_left container__content">
			<div className="container__content-title">
				<h2 className="font-proxima-nova-bold">{props.intl('Новости')}</h2>
			</div>

			<div className="news-half__list">
				<NewsList
					rows={props.dataTable.data}
					openedNewsId={props.openedNewsId}
					openedNewsOffers={props.openedNewsOffers}
					toggleNews={props.toggleNews}
					newsTypesEnum={props.newsTypesEnum}
					isCanNotMoveToNext={props.dataTable.isCanNotMoveToNext}
					showMore={props.pagination().showMore}
					intl={props.intl}
				/>
			</div>
		</div>
		<div className="column_right">
			<div className="container__content">
				<div className="container__content-title">
					<h2 className="font-proxima-nova-bold">{props.intl('Фильтры')}</h2>
				</div>
				{ <Filters {...props} /> }
			</div>
		</div>
	</div>
));

export default connect(
	state => ({
		data: selectors.getData(state),
		dataTable: selectors.getTableData(state),
		newsTypesEnum: selectors.getNewsTypesEnum(),
		localizedNewsTypes: selectors.getLocalizedNewsTypes(state),
		openedNewsId: selectors.getOpenedNewsId(state),
		openedNewsOffers: selectors.getOpenedNewsOffers(state),
		calendar: selectors.getCalendar(state),
		intl: selectors.getIntl(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/news/main.js